export const SET_INVENTORY_WAREHOUSE = 'SET_INVENTORY_WAREHOUSE';

export const actionMap = {
  [SET_INVENTORY_WAREHOUSE]: (state, { inventoryWarehouse }) => {
    return {
      ...state,
      inventoryWarehouse,
    };
  },
};

export const initialState = {
  inventoryWarehouse: undefined,
};
